import {Component} from "@angular/core";
import {apiconfig} from "../../../app/api.config";
import {Order} from "../../../model/Order";
import {OrderService} from "../../../services/OrderService";
import {NavController, NavParams} from "ionic-angular";
import {AdditionalTimes} from "../../../model/AdditionalTimes";
import {DateService} from "../../../services/DateService";

@Component({
  selector: 'page-additional-view',
  templateUrl: 'additional-view.html',
})
export class AdditionalTimesViewPage {

  public iconsURL: string = apiconfig.LOGA_ICONS;
  order: Order;

  additionalTimes: AdditionalTimes[] = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public dateService: DateService,
              public orderService: OrderService) {

  }

  public toHrDate(p_epochDay: number) {
    return this.dateService.toDate(p_epochDay)
  }


  ionViewWillEnter() {
    this.order = this.navParams.data;
    this.orderService.loadAdditionalWorkingTime(this.order.id).then(
      (response) => {
        this.additionalTimes = response;
      }).catch(err => {
      this.navCtrl.pop();
    });
  }


  onSave() {
    this.orderService.saveAdditionalWorkingTime(this.order.id, this.additionalTimes)
      .then((response) => {
        return this.navCtrl.pop();
      }).catch(err => {

    });
  }
}




// WEBPACK FOOTER //
// ./src/pages/order-view/additional/additional-view.ts